export function getBody () {
  var doc = document,
      body = doc.body;

  if (!body) {
    body = doc.createElement('body');
    body.fake = true;
  }

  return body;
}


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/repos/dmv-image-4/app/wordpress/wp-content/themes/dmv/node_modules/tiny-slider/src/helpers/getBody.js
// module id = 2
// module chunks = 0